<template>
    <div class="vue-deksoft" >
        <div v-for="(composition, index) in compositions" :key="index" class="vue-deksoft__item">
            <h2 class="vue-deksoft__title" >{{ composition.name }}</h2>

            <div class="vue-deksoft__image">
                <img :src="composition.image"  width="300" />
            </div>

            <div class="vue-deksoft__content">

                <div class="vue-deksoft__content-left">
                    <h3>Obvyklé použití</h3>
                    <ul>
                        <li v-for="(place, index) in composition.usage" :key="index">
                            {{ place }}
                        </li>
                    </ul>

                    <h3>Charakteristika</h3>
                    <div v-html="composition.characteristic"></div>
                </div>

                <div class="vue-deksoft__content-right">
                    <h3>Specifikace</h3>
                    <ul>
                        <li v-for="(specification, index) in composition.specifications" :key="index">
                            <a v-if="specification.url" :href="specification.url" target="_blank">{{ specification.name }}</a>
                            <span v-if="!specification.url">{{ specification.name }}</span>
                        </li>
                    </ul>
                </div>

            </div>

            <div class="vue-deksoft__buttons">
                <a v-if="composition.pdf" :href="composition.pdf" role="button" target="_blank" class="dek-button-green">PDF</a>
                <a v-if="composition.video" :href="composition.video" role="button" class="dek-button-green">Video</a>
                <a v-if="composition.catalogue" :href="composition.catalogue" role="button" class="dek-button-green">Katalogový list</a>
                <a v-if="composition.details" :href="composition.details" role="button" class="dek-button-green">Detaily</a>
                <a v-if="composition.thermal" :href="composition.thermal" role="button" class="dek-button-green">Tepelná technika</a>
                <a v-if="composition.configurator" :href="composition.configurator" role="button" class="dek-button-green">Kalkulace</a>
            </div>
        </div>

    </div>
</template>

<script lang="ts">
import { defineComponent, computed, SetupContext } from 'vue'
import useStore from './store'

const store = useStore(window.pinia)

export default defineComponent({
    setup (props: SetupContext['attrs'], { attrs }) {
        store.fetchList(attrs.compositionIds as string[])

        return {
            compositions: computed(() => store.getList()),
        }
    },
})
</script>
